import {CommandsContext} from 'context';
import * as React from 'react';
import {Command} from 'hooks';

export enum ActionType {
	ADD_COMMAND = 'ADD_COMMAND',
	REMOVE_COMMAND = 'REMOVE_COMMAND',
}

type State = Command[];

const initialState: State = [];

export function reducer(
	state: State,
	{type, command}: {type: ActionType; command: Command},
): State {
	switch (type) {
		case ActionType.ADD_COMMAND:
			return state.some(x => x.key === command.key)
				? state.map(x => (x.key === command.key ? command : x))
				: [...state, command];
		case ActionType.REMOVE_COMMAND:
			return state.filter(x => x.key !== command.key);
		default:
			return initialState;
	}
}

export const CommandsProvider: React.FC<{children: React.ReactNode}> = ({
	children,
}) => {
	const [commands, dispatch] = React.useReducer(reducer, initialState);
	const removeCommand = React.useMemo(
		() => (command: Command) => {
			dispatch({type: ActionType.REMOVE_COMMAND, command});
		},
		[dispatch],
	);
	const addCommand = React.useMemo(
		() => (command: Command) => {
			dispatch({type: ActionType.ADD_COMMAND, command});

			return () => removeCommand(command);
		},
		[dispatch, removeCommand],
	);

	const contextValue = React.useMemo(
		() => ({commands, addCommand, removeCommand}),
		[commands, addCommand, removeCommand],
	);

	return (
		<CommandsContext.Provider value={contextValue}>
			{children}
		</CommandsContext.Provider>
	);
};
